import type { ReactNode } from "react";
import { useState } from "react";
import { Button, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import type Article from "models/Article";
import type CommandeArticleCartModel from "models/CommandeArticleCartModel";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "notistack";
import { addArticle } from "reducers/cartReducer";
import ToastMessages from "constants/ToastMessages";
import { rangeUtil } from "utils/rangeUtil";

interface CartActionsProps {
  article: Article;
  justifyContent?: "center" | "start" | "end" | "flex-start" | "flex-end" | "left" | "right";
  alignContent?: "center" | "start" | "end" | "flex-start" | "flex-end" | "normal";
}

function CartActions({
  article,
  justifyContent,
  alignContent,
}: Readonly<CartActionsProps>): ReactNode {
  const [quantite, setQuantite] = useState<number>(0);
  const [taille, setTaille] = useState<string>(initTaille);
  const dispatch = useDispatch();

  function initTaille(): string {
    return article.uniteMesureTaille === "Taille unique" ? "Taille unique" : "";
  }

  function addArticleToCart(): void {
    const commandArticle: CommandeArticleCartModel = {
      quantite,
      taille,
      articleLabel: article.label,
      articleId: article.id,
      quantiteMax: article.quantiteMax,
    };
    dispatch(addArticle(commandArticle));

    enqueueSnackbar(ToastMessages.PANIER_AJOUT, { variant: "success" });

    setTaille(initTaille);
    setQuantite(0);
  }

  return (
    <Grid
      container
      spacing={1}
      size={12}
      sx={{ alignItems: "center", justifyContent, alignContent }}>
      <Grid size={{ xs: "grow", sm: "auto" }} sx={{ minWidth: "100px" }}>
        <FormControl fullWidth size="small">
          <InputLabel>Quantité</InputLabel>
          <Select
            size="small"
            label="Quantité"
            value={quantite}
            fullWidth
            onChange={(event) => {
              setQuantite(event.target.value);
            }}>
            {rangeUtil.arrayRange(article.quantiteMax + 1).map((i) => (
              <MenuItem key={i} value={i}>
                {i}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={{ xs: "grow", sm: "auto" }} sx={{ minWidth: "160px" }}>
        <FormControl fullWidth size="small">
          <InputLabel>Taille</InputLabel>
          <Select
            label="Taille"
            value={taille}
            onChange={(event) => {
              setTaille(event.target.value);
            }}>
            {article.tailles?.map((t) => (
              <MenuItem key={t} value={t}>
                {t}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={{ xs: "grow", sm: "auto" }} sx={{ minWidth: "110px" }}>
        <Button
          disabled={quantite === 0 || taille === ""}
          variant="contained"
          onClick={addArticleToCart}
          endIcon={<AddShoppingCartIcon />}
          fullWidth>
          Ajouter
        </Button>
      </Grid>
    </Grid>
  );
}

export default CartActions;
